/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';
import { DirectorListPageAgent, getAgent } from './agent';
import { InviteUserProps } from './plugins';
import { logger as log } from '../../../common/logger';
const is = require('is_js');

const SERVICE_NAME = 'DirectorListPageService';

@injectable()
export class DirectorListPageService {
  private static instance: DirectorListPageService;
  public agent: DirectorListPageAgent;
  private loginRestAPI: string;
  private criteria: any;
  private headers: any;
  private token: string;
  private userRoles: any;
  static displayName = 'DirectorListPageService';
  constructor(props: any = {}) {
    this.agent = getAgent();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
    this.userRoles = props?.userRoles;
  }

  private setCriteria(data: any) {
    this.criteria = [...this.criteria, ...data];
  }

  public resetCriteria() {
    this.criteria = [];
  }

  public async getPageContent(args: any) {
    console.log(`abcd::`);
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getUserListsProps(args?.criteria);
    this.userRoles = compProps?.userRoles;

    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async inviteUser(args: InviteUserProps) {
    log.log(`invite user`, args);
    let _args = {
      ...args,
      loginRestAPI: this.loginRestAPI,
      headers: this.headers,
      token: this.token,
      userRoles: this.userRoles,
    };
    const agent = getAgent();
    return agent.getInviteUser(_args);
  }

  public async deleteUser(args: any) {
    const agent = getAgent();
    return agent.getDeleteUser(args);
  }

  public async suspendUser(args: any) {
    log.log(`suspend  user service`, args);
    const agent = getAgent();
    return agent.getSuspendUser(args);
  }

  public async activateUser(args: any) {
    const agent = getAgent();
    return agent.getActivateUser(args);
  }

  public async reInviteUser(args: any) {
    log.log(`reset user service`, args);
    const agent = getAgent();
    return agent.getReInviteUser(args);
  }
}
